import { ButtonHTMLAttributes } from 'react';

export enum EButtonType {
    Primary,
    Secondary,
    Outline,
    Contrast,
    Danger,
}

export enum EButtonSize {
    Big,
    Normal,
    Small,
}

export type TButton = {
    noPadding?: boolean;
    isLoading?: boolean;
    onClick?: () => void;
    styleType?: EButtonType;
    size?: EButtonSize;
    disabled?: boolean;
    inline?: boolean;
    wide?: boolean;
    color?: 'primary' | 'secondary';
} & ButtonHTMLAttributes<HTMLButtonElement>;
